import { render, staticRenderFns } from "./TrashProductHistorical.vue?vue&type=template&id=30c602dd&scoped=true"
import script from "./TrashProductHistorical.vue?vue&type=script&lang=js"
export * from "./TrashProductHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c602dd",
  null
  
)

export default component.exports